import { render } from "./Primary3.vue?vue&type=template&id=3b2676ec&ts=true"
import script from "./Primary3.vue?vue&type=script&lang=ts"
export * from "./Primary3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Primary3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b2676ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b2676ec', __exports__)) {
    api.reload('3b2676ec', __exports__)
  }
  
  module.hot.accept("./Primary3.vue?vue&type=template&id=3b2676ec&ts=true", () => {
    api.rerender('3b2676ec', render)
  })

}


export default __exports__